.vc-pip-button {
    color: var(--interactive-normal);
}

.vc-pip-button:hover {
    background-color: var(--background-modifier-hover);
    color: var(--interactive-hover);
}
